import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { PopupContext } from "../../index";
import * as additionalAlgorithmService from "./additionalAlgorithmService";
import { getConfirmPopup, getClosePopup } from "../../view/popup/PopupContainer";
import { showSuccessToast, showDangerToast } from "../../validation/ToastContainer";

function SSHAlgorithmField({ value, device, onChange }) {

    const history = useHistory();
    const { setPopup } = useContext(PopupContext);

    const handleChange = (value) => {
        onChange(value);
    }

    const onSaveClick = async () => {
        if (device) {
            const newSSHAlgorithm = {
                deviceId: device.id,
                sshAlgorithm: value,
            }

            const valid = await additionalAlgorithmService.validateSShAlgorithmOptionsFormat(newSSHAlgorithm);

            switch (valid) {
                case 'true':
                    setPopup(
                        getConfirmPopup('Are you sure?',
                            'Update Device SSH Algorithm Options',
                            () => additionalAlgorithmService.saveDeviceSSHAlgorithm(newSSHAlgorithm)
                                .then(success => {
                                    if (success) {
                                        showSuccessToast('SSH Algorithm Options for the Selected Device are updated successfully', 'Update Device SSH Algorithm Options');
                                        history.go(0)
                                    } else {
                                        showDangerToast('There was an error updating the SSH Algorithm, please review with support', 'Update Device SSH Algorithm Options');
                                    }
                                }
                                )
                        )
                    )
                    break;
                case 'kex':
                    setPopup(
                        getClosePopup('There are missing structure format characters in the kex part (ex. comma, single-qoute). Please fix it and save again!', 'Structure Format Issue in the kex part',))
                    break;
                case 'cipher':
                    setPopup(
                        getClosePopup('There are missing structure format characters in the cipher part (ex. comma, single-qoute). Please fix it and save again!', 'Structure Format Issue in the cipher part',))
                    break;
                case 'hmac':
                    setPopup(
                        getClosePopup('There are missing structure format characters in the hmac part (ex. comma, single-qoute). Please fix it and save again!', 'Structure Format Issue in the hmac part',))
                    break;
                case 'shk':
                    setPopup(
                        getClosePopup('There are missing structure format characters in the serverhostkey part (ex. comma, single-qoute). Please fix it and save again!', 'Structure Format Issue in the serverhostkey part',))
                    break;
                case 'gm':
                    setPopup(
                        getClosePopup('There are missing structure format characters (ex. [, :, comma, single-qoute). Please fix it and save again!', 'General Structure Format Issue',))
                    break;
                default:
                // code block
            }
        }
    }

    return (
        <div className="oct_settings-field mt-3">
            <label className="oct_settings-label">SSH Algorithm Options</label>
            <textarea
                className="oct_settings-textarea"
                rows={8}
                value={value}
                onChange={(e) => handleChange(e.target.value)}
            />
            <button
                type="button"
                className="oct_settings-btn-v2 mt-3"
                onClick={() => onSaveClick()}
            >
                Save
            </button>
        </div>
    )
}

export default SSHAlgorithmField;
